import { useContext, useMemo } from 'react';
import { type CompanyWithPermissionsContextDataFragment } from '../../../api/fragments';
import { type CompanyContextDataFragment } from '../../../api/fragments/CompanyContextData';
import { type Maybe } from '../../../api/types';
import { CompanyContext, type CompanyContextData } from './Context';

export const useCompanyContext = () => {
    const context = useContext(CompanyContext);

    if (!context) {
        throw new Error('Company context is missing');
    }

    return context;
};

/* eslint-disable no-redeclare */
export function useCompany(optional: true): Maybe<CompanyWithPermissionsContextDataFragment>;
export function useCompany(optional?: false): CompanyWithPermissionsContextDataFragment;
export function useCompany(optional?: boolean): CompanyWithPermissionsContextDataFragment {
    const { companies, allCompaniesSelected } = useCompanyContext();

    if (!optional && companies.length !== 1) {
        throw new Error('Company data is missing');
    }

    if (allCompaniesSelected && companies.length > 1) {
        return null;
    }

    return companies[0] || null;
}

export function useCompanies(optional: true): Maybe<CompanyContextDataFragment[]>;
export function useCompanies(optional?: false): CompanyContextDataFragment[];
export function useCompanies(optional?: boolean): CompanyContextDataFragment[] {
    const { companies } = useCompanyContext();

    if (!optional && !companies) {
        throw new Error('Company data is missing');
    }

    return companies;
}
/* eslint-enable no-redeclare */
